export default {
  profile: {
    menu: {
      settings: "Instillinger",
      logOut: "Logg ut",
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/layout/navigation/topbar.js